<template>
  <v-dialog v-model="dialogLocal" max-width="600px" @click:outside="close">
    <v-card>
      <v-card-title>
        Adjuntar archivo a: {{ nodoName || 'Nodo' }}
      </v-card-title>
      <v-card-text>
        <v-text-field
          v-model="nombreArchivo"
          label="Nombre del archivo"
          required
        />
        <v-textarea
          v-model="descripcionArchivo"
          label="Descripción (opcional)"
          rows="3"
        />
        <v-file-input
          v-model="archivoAdjunto"
          label="Selecciona archivo"
          accept="*/*"
          required
          show-size
        />
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn text @click="close">Cancelar</v-btn>
        <v-btn color="primary" @click="submit">Subir</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    dialog: Boolean,
    nodoName: String
  },
  data() {
    return {
      nombreArchivo: '',
      descripcionArchivo: '',
      archivoAdjunto: null,
      dialogLocal: false,
    }
  },
  watch:{
    dialog(newVal) {
      this.dialogLocal = newVal
    },
    dialogLocal(newVal) {
      if (!newVal) {
        this.$emit('update:dialog', false)
      }
    }
  },
  mounted(){
    this.dialogLocal = this.dialog
  },
  methods: {
    close() {
      this.$emit('update:dialog', false)
      this.resetFields()
    },
    resetFields() {
      this.nombreArchivo = ''
      this.descripcionArchivo = ''
      this.archivoAdjunto = null
    },
    submit() {
      // Puedes validar aquí
      if (!this.nombreArchivo || !this.archivoAdjunto) {
        alert('Completa todos los campos requeridos')
        return
      }
      this.$emit('upload', {
        nombreArchivo: this.nombreArchivo,
        descripcionArchivo: this.descripcionArchivo,
        archivoAdjunto: this.archivoAdjunto
      })
      this.close()
    }
  }
}
</script>
